import { Routes, Route, useLocation } from 'react-router-dom'
import Header from './components/sections/header'
import Footer from './components/sections/Footer'
import HomePage from './pages/HomePage'
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'
import TermsOfServicePage from './pages/TermsOfServicePage'
import ChildSafetyPolicyPage from './pages/ChildSafetyPolicyPage'
import DeleteMyAccountPage from './pages/DeleteMyAccountPage'
import ComingSoon from './components/ComingSoon'

function App() {
  const location = useLocation()
  const allowedPaths = new Set(['/privacy-policy', '/delete-my-account', '/terms-of-service', '/child-safety-policy'])

  if (!allowedPaths.has(location.pathname)) {
    return <ComingSoon />
  }

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          <Route path="/child-safety-policy" element={<ChildSafetyPolicyPage />} />
          <Route path="/delete-my-account" element={<DeleteMyAccountPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  )
}

export default App
